export default {
  submitError: null,
  submitSuccess: false,
  requests: [],
  selectedRequest: null,
  isLoading: false,
  nextPageKey: null
}
